{
    "_or": "or",
    "abonoLogo": "Abonoteatro",
    "abonoTeatroInfo": "Info AbonoTeatro",
    "abonoTeatroSettings": "AbonoTeatro Settings",
    "accept": "Accept",
    "accompanying": "Accompanying person",
    "accompanyingCosts": "Accompanying costs",
    "accompanyingPVP": "Accompanying PVP",
    "accompanyingPerSubscriber": "Accompanying per subscriber",
    "accompanyingTicket": "Accompanying ticket",
    "accompanyingTickets": "Accompanying tickets",
    "accompanyingTickets_short": "Accomp. Tick.",
    "accompanying_short": "Accomp.",
    "accompanyings": "Accompanying people",
    "accompanyingsPerSubscription": "Subscription accompanyings",
    "activatedSubscriptions": "Activated subscriptions",
    "activationDate": "Activation date",
    "active": "Active",
    "activeSubscriberNotFound": "No active subscriber found",
    "activeSubscriptions": "Actived subscriptions",
    "adaptedForDeaf": "Adapted for deaf",
    "adaptedForDeaf_short": "Deaf",
    "adaptedForWheelchair": "Adapted for wheelchair",
    "adaptedForWheelchair_short": "Wheelch.",
    "add": "Add",
    "addCodes": "Add codes",
    "addCompany": "Add company",
    "addConfiguration": "Add configuration",
    "addDiscountCode": "Add discount code",
    "addEnclosure": "Add enclosure",
    "addMarket": "Add market",
    "addProduct": "Add product",
    "addProducts": "Add products",
    "addQuestion": "Add question",
    "addSession": "Add session",
    "addType": "Add type",
    "addUser": "Add user",
    "addZoneAndSeats": "Add zone and seats",
    "adding": "Adding",
    "address": "Address",
    "advice": "NOTICE",
    "agents_may": "Agent(s)",
    "aggregate": "Aggregate",
    "aggregates": "Aggregates",
    "agreements": "Agreements",
    "alert": "Alert",
    "all": "All",
    "allEvents": "All events",
    "allStatuses": "All statuses",
    "all_plural": "All",
    "amount": "Amount",
    "amountShorted": "Amo.",
    "answer": "Answer",
    "answeredOnDatetime": "Answered on {{date}} {{hour}}h",
    "appName": "Abonoteatro",
    "applicableTo": "Applicable to",
    "applicableVat": "Applicable VAT",
    "applyToManagementCosts": "Apply to management cost?",
    "approve": "Approve",
    "article": "Article",
    "assessment": "Assessment",
    "assessments": "Assessments",
    "assignPassword": "Assign password",
    "assignToMe": "Assign to me",
    "assignToMeNow": "Assign to me now",
    "assignedToMe": "Assigned to me",
    "associateThisUserToOneOrMoreMarkets": "You associate this user to one or more markets. Each marketplace supports multiple roles.",
    "attachImage": "Attach image",
    "attachImages": "Attach images",
    "authorized": "Authorized",
    "authorizedSubscriberTicket": "Authorized Ticket",
    "automaticRenewal": "Automatic renewal",
    "automaticRenewal_short": "Aut. Renew.",
    "automaticRenewals": "Automatic renewals",
    "availability": "Availability",
    "availableAtEventsInOtherMarkets": "Available at events in other markets",
    "averageAssessment": "Average assessment",
    "averagePrice": "Average price",
    "averageSubscriptionPrice": "Average subscription prices",
    "avgTicketPrice": "Average ticket price",
    "back": "Go back",
    "basicData": "Basic data",
    "beneficiaries": "Beneficiaries",
    "beneficiary": "Beneficiary",
    "billing": "Billing",
    "billing_priceBySubscriber": "Billing (price by subscriber)",
    "birth": "Birthday",
    "birthday": "Birthday",
    "breadcrumbs": "Breadcrumbs",
    "bulkEdition": "Bulk edition",
    "businessName": "Business name",
    "buyer": "Buyer",
    "byDefault": "By default",
    "cancel": "Cancel",
    "categories": "Categories",
    "category": "Category",
    "changePassword": "Change password",
    "changesOfLegacyData": "Changes of legacy data",
    "characterAlphaNumLengthLimitRange": "should be between {{min}} and {{max}}",
    "characterLength": "Character Nº",
    "charactersMaximum": "Characters maximum",
    "checkUncheckAll": "Check / Uncheck all",
    "checkUncheckAllCapabilities": "Check / Uncheck all capabilities",
    "childrenDiscount": "Discount",
    "chooseASessionToModify": "Choose a session to modify",
    "chooseASessionToModifyAdvice": "Although the sessions have been created in bulk globally, you can modify specific details of each session.",
    "chooseFromOneOfTheseOptions": "Choose from one of these options",
    "cifNif": "CIF/NIF",
    "close": "Close",
    "closeSidebar": "Close sidebar",
    "closingReportEmails": "Closing report emails",
    "code": "Code",
    "codes": "Codes",
    "codesGeneratedCorrectly": "Codes generated correctly",
    "codesImportedSuccessfully": "Codes imported successfully",
    "codesList": "Code list",
    "codesOutOfTotalHaveBeenImported_one": "{{count}} code has been imported out of {{total}} total.",
    "codesOutOfTotalHaveBeenImported_other": "{{count}} codes have been imported out of {{total}} total.",
    "column": "Column",
    "comment": "Comment",
    "commercial": "Commercial",
    "commercials": "Commercials",
    "companies": "Companies",
    "company": "Company",
    "companyCreatedSuccessfully": "Company created successfully",
    "companyDeletedSuccessfully": "Company deleted successfully",
    "companyUpdatedSuccessfully": "Company updated successfully",
    "complete_verb": "Complete",
    "completedSuccessfully": "Completed successfully",
    "concept": "Concept",
    "conditions": "Conditions",
    "configuration": "Configuration",
    "configure": "Configure",
    "configureSendingReports": "Configure sending reports",
    "confirmThisAction": "Confirm this action, please.",
    "confirmThisOperation": "Confirm this operation, please.",
    "consult": "Consult",
    "contactEmail": "Contact email",
    "contactName": "Contact person",
    "contactPhone": "Contact phone",
    "continue": "Continue",
    "conversationHistory": "Conversation history",
    "copied": "Copied",
    "copy": "Copy",
    "corporatePromoters": "Corporate promoters",
    "create": "Create",
    "createAlsoIn": "Create also in",
    "createCodes": "Create codes",
    "createSessions": "Create sessions",
    "createSubscription": "Add subscription",
    "createUpdateProduct": "Create/Update product",
    "creatingSessions": "Creating sessions",
    "creationDate": "Creation date",
    "creationDate_short": "Creation",
    "current": "Current",
    "customerService": "Customer service",
    "customizationOfSubscriptionNumber": "Customization of Subscription Number",
    "dailyDispatch": "Daily dispatch",
    "dataPanel": "Data panel",
    "date": "Date",
    "dateCreation": "Creation date",
    "dateCreation_alt": "Creation",
    "dateFrom": "Date from",
    "dateTo": "Date to",
    "deactivationDate": "Deactivation date",
    "deactivationDate_short": "Deact. date",
    "defineSessions": "Define sessions",
    "delete": "Delete",
    "deleteIgnoringHavingRelatedSubscriptionTypes": "Delete regardless of whether you have related subscription types",
    "deleteIndividualSessionAdvice": "Delete individual session? This action is final, it cannot be undone.",
    "deleteMassiveSessionsAdvice": "Delete selected sessions? This action is final, it cannot be undone.",
    "delete_alt": "Remove",
    "deletedSuccessfully": "Deleted successfully",
    "derived": "Derived",
    "derivedOperations": "Derived operations",
    "description": "Description",
    "destinatarie": "Destinatarie",
    "destinataries": "Destinataries",
    "detail": "Detail",
    "detailedNumberOfUses": "Detailed number of uses",
    "details": "Details",
    "disable": "Disable",
    "disabled": "Disabled",
    "discount": "Discount",
    "discountCode": "Discount code",
    "discountCodeCreatedSuccessfully": "Discount code created successfully",
    "discountCodeDeletedSuccessfully": "Discount code deleted successfully",
    "discountCodeUpdatedSuccessfully": "Discount code updated successfully",
    "discountCodes": "Discount codes",
    "discountCodesList": "Discount code list",
    "discountCodesUpdatedSuccessfully": "Discount codes updated successfully",
    "discountName": "Discount name",
    "discountPercentage": "Discount percentage",
    "discountPercentage_short": "Disc. Perc.",
    "discountPrice": "Discount price",
    "discountPrice_short": "Disc. Price",
    "discountPromotedBy": "Discount promoted by",
    "discountQuantity": "Discount quantity",
    "discountQuantity_short": "No Disc.",
    "discount_AMOUNT": "Amount Discount",
    "discount_BASE_PRICE": "Base Price Discount",
    "discount_PERCENTAGE": "Percentage Discount",
    "discount_short": "Disc.",
    "discounts": "Discounts",
    "dispatchByAction": "Dispatch by action",
    "doYouWantToDeletePermanently": "o you want to delete permanently?",
    "doYouWantToSendANotificationToUsersWithTicket": "Do you want to send notification to users with ticket?",
    "download": "Download",
    "downloadPreview": "Download preview",
    "downloading": "Downloading",
    "duplicate": "Duplicate",
    "duplicating": "Duplicating",
    "duration": "Duration",
    "duration_days": "Duration (days)",
    "edit": "Edit",
    "editEmail": "Edit email",
    "editPdf": "Edit PDF",
    "editRole": "Edit role",
    "editedBy": "Edited by",
    "editedBy_female": "Edited by",
    "editedBy_male": "Edited by",
    "email": "Email",
    "emailBanner": "Email banner",
    "emailFormat": "Email Format",
    "emailTemplate": "Email template",
    "email_short": "Email",
    "emails": "Emails",
    "emailsGeneral": "General emails",
    "emailsMustBeSeparatedWithSemicolon": "Emails must be separated with ;",
    "emailsSeparatedBy": "Emails separated by",
    "emptyReportingsMessage": "There are currently no reports scheduled for this site.",
    "enable": "Enable",
    "enabled": "Enabled",
    "enclosure": "Enclosure",
    "enclosureCreatedSuccessfully": "Enclosure created successfully",
    "enclosureDeletedSuccessfully": "Enclosure deleted successfully",
    "enclosureSeating": "Enclosure seating",
    "enclosureType": "Enclosure type",
    "enclosureUpdatedSuccessfully": "Enclosure updated successfully",
    "enclosures": "Enclosures",
    "end": "End",
    "end_noun": "End",
    "entryDate": "Entry date",
    "erase": "Erase",
    "errorResendsFailed": "It was not possible to make resend",
    "errorReturnsFailed": "It was not possible to make refunds",
    "errorSendingExportByEmail": "Error sending export by email",
    "event": "Event",
    "eventCreatedSuccessfully": "Event created successfully",
    "eventDate": "Event date",
    "eventDeletedSuccessfully": "Event deleted successfully",
    "eventDetailsUrlWebsiteInfo": "<div><p>In order to view the event page it's required:</p><ul><li>- To have a website user</li><li>- To have at least one active subscription</li><li>- To have the event published</li><li>- To have available sessions</li></ul></div>",
    "eventDuration_min": "Event duration (min)",
    "eventEnd": "Event End",
    "eventFormat": "Event format",
    "eventImage": "Event image",
    "eventMerchandising": "Event merchandising",
    "eventName": "Event name",
    "eventPVP": "Event PVP",
    "eventSoloInfoScope": "Scope \"Only info\"",
    "eventStart": "Event Start",
    "eventSubtitle": "Event subtitle",
    "eventTitle": "Event title",
    "eventUpdatedSuccessfully": "Event updated successfully",
    "events": "Events",
    "eventsStatus": "Events Status",
    "executeResend": "Execute resend",
    "executeReturn": "Execute return",
    "expirationDate": "Expiration date",
    "expirationDate_short": "Expiration",
    "expiredSubscriptions": "Expired subscriptions",
    "exportFormat": "Export format",
    "exportSelectedSessions": "Export selected sessions",
    "exportSentByEmail": "Export sent by email",
    "featured": "Featured",
    "fieldsToBeUpdatedWillBe": "The fields to be updated will be",
    "file": "File",
    "file_sheet": "File",
    "filters": "Filters",
    "final": "Final",
    "finalSeparator": "&",
    "finish": "Finish",
    "firstEnclosure": "First enclosure",
    "firstEvent": "First event",
    "firstName": "Firstname",
    "fiscalAddress": "Fiscal address",
    "forActualValuesYouMustSelectASingleSession": "To know the real values you must select a single session",
    "forgotPassword": "I forgot the password",
    "formIcon": "Form icon",
    "format": "Format",
    "frequency": "Frequency",
    "fromTo": "From - To",
    "gallery": "Gallery",
    "gender": "Gender",
    "gender_short": "Gen.",
    "generalInfo": "General info",
    "generalRecipientsForAllReports": "Generic recipients for all reports",
    "generalTemplates": "General templates",
    "generals": "Generals",
    "generate": "Generate",
    "generateSessions": "Generate sessions",
    "gift": "Gift",
    "gifts": "Gifts",
    "goTo": "Go to",
    "header": "Header",
    "hidePassword": "Hide password",
    "home": "Home",
    "hour": "Hour",
    "ifEmailIsValidThenResetPasswordWillBeSent": "If the email '{{email}}' address is correct, you will receive an email to reset your password.",
    "image": "Image",
    "image_short": "Img.",
    "import": "Import",
    "importCodes": "Import codes",
    "importDiscountCodes": "Import discount codes",
    "importDiscountsInBulkFromAnExternalFile": "You can import discount codes from an external file, in .CSV format.",
    "importFile": "Import file",
    "inactive": "Inactive",
    "incidence": "Incidence",
    "incidenceCreatedSuccessfully": "Incidence created successfully",
    "incidenceDeletedSuccessfully": "Incidence deleted successfully",
    "incidenceUpdatedSuccessfully": "Incidence updated successfully",
    "incidences": "Incidences",
    "individual": "Individual",
    "individualSession": "Individual session",
    "individualSession_short": "Indiv. sess.",
    "information": "Information",
    "inheritedFrom": "Inherited from",
    "internalNote": "Internal note",
    "issuedReports": "Issued reports",
    "issuedSubscriptions": "Issued subscriptions",
    "language": "Language",
    "languages": "Languages",
    "lastEdit": "Last edit",
    "lastName": "Lastname",
    "latestIncidences": "Latest incidences",
    "latestOperations": "Latest operations",
    "leadIncidence": "Non subscriber incidence",
    "leads": "Leads",
    "liable": "Liable",
    "limited": "Limited",
    "lineBreak": "line break",
    "list": "List",
    "loading": "Loading",
    "loading_dots": "Loading...",
    "login": "Login",
    "logo": "Logo",
    "logout": "Logout",
    "main": "Main",
    "mainMarket": "Main market",
    "main_short": "Main",
    "management": "Management",
    "managementCompany": "Management company",
    "managementCompany_short": "Management",
    "managementCostShorted": "M. Cost",
    "managementCosts": "Management costs",
    "managementCosts_short": "M. costs",
    "managementNumber": "Management number",
    "managementPanel": "Management panel",
    "manualRenewals": "Manual renewals",
    "market": "Market",
    "markets": "Markets",
    "massive": "Massive",
    "massiveResend": "Massive resend",
    "massiveResend_1": "Massive subscription resend",
    "massiveResend_2": "Massive gift subscription resend",
    "massiveResend_3": "Massive renewal subscription resend",
    "massiveTicketReturn": "Massive ticket return",
    "massiveTicketsResend": "Massive ticket resend",
    "maxAuthorizedPerSubscription": "Max number of authorized per susbcription",
    "maxCharacters": "maximum {{number}} characters",
    "maxTimeInCart": "Max number of waiting time in cart",
    "maxUsages": "Maximum of usages",
    "maxUsages_short": "Max. uses",
    "merchandising": "Merchandising",
    "message": "Message",
    "minor": "Minor",
    "minorBirthday": "Minor birthday",
    "minorBirthday_short": "Minor birthday",
    "minorName": "Minor name",
    "minorSubscriberTicket": "Minor Ticket",
    "multipleSession": "Multiple session",
    "multipleSession_short": "Multiple sess.",
    "name": "Name",
    "new": "New",
    "newCompany": "New company",
    "newRole": "New role",
    "newUser": "New user",
    "newsletters": "Newsletter",
    "no": "No",
    "noOptionsFound": "No options found",
    "noResultsFound": "No results found",
    "noStatus": "No status",
    "noTemplatesYet": "No templates yet",
    "noValue": "No value",
    "nonSubscriberMessage": "Non-subscriber message",
    "nonSubscribersMessages": "Non-subscribers messages",
    "notImplementYet": "Not implemented yet",
    "note": "Note",
    "noteIncludedInUserEmail": "Note included in the email to the user",
    "notice": "Notice",
    "notification": "Notification",
    "notificationCreatedSuccessfully": "Notification created successfully",
    "notificationSentToSubscriberEmail": "Notification sent to subscriber email",
    "notifications": "Notifications",
    "nrOfAccompanyings": "Nr of accompanying",
    "nrOfAccompanyings_short": "Nr accomp.",
    "nrOfProducts": "Nr of products",
    "nrOfProducts_short": "Nr prod.",
    "nrOfSubscribers": "Nr of subscribers",
    "nrOfSubscribers_short": "Nr subscr.",
    "nrOfTickets": "Nr of tickets",
    "nrOfTickets_short": "Nr tick.",
    "number": "Number",
    "numberOfCodes": "N of codes",
    "numberOfSeats": "No. of seats",
    "numberOfSoldTickets": "Sold tickets",
    "numberOfSoldTicketsAsAccompanying": "Sold tickets as accompanying",
    "numberOfSoldTicketsAsSubscriber": "Sold tickets as subscriber",
    "number_short": "No.",
    "observations": "Observations",
    "ok": "Ok",
    "onceCreatedYouWillNotBeAbleToChangeThePersonalisation": "Once created, you won't be able to modify the customization. If you need to change it, create a new subscription.",
    "operation": "Operation",
    "operationDate": "Operation date",
    "operationDate_short": "Op. date",
    "operationDatetime": "Operation date",
    "operationDatetime_short": "Op. datetime",
    "operationId": "Operation ID",
    "operationId_short": "Op. ID",
    "operationStatusModifiedSuccessfully": "Operation status modified successfully",
    "operationType": "Operation type",
    "operationType_short": "Op. type",
    "operations": "Operations",
    "optional": "Optional",
    "organization": "Organization",
    "origin": "Origin",
    "originalPrice": "Original price",
    "page": "Page",
    "pageNotExist": "The page you are looking for doesn't exist",
    "pageNotFound": "Page not found",
    "pageUpdatedSuccessfully": "Page updated successfully",
    "page_short": "Page",
    "paramIsRequired": "Param {{value}} is required.",
    "parentDiscount": "Parent discount",
    "partialRefund": "Partial refund",
    "password": "Password",
    "passwordAssignMessage": "Once you assign a password for your account, you will be able to access the application.",
    "passwordRepeat": "Repeat password",
    "passwordUpdatedSuccessfully": "Password updated successfully",
    "paymentCode": "Redsys code",
    "paymentDate": "Payment date",
    "paymentDatetime": "Payment date",
    "paymentId": "Payment ID",
    "pdfFormat": "PDF Format",
    "pdfTemplate": "PDF template",
    "permanent": "Permanent",
    "personalData": "Personal data",
    "phone": "Phone",
    "phone_optional": "Phone (optional)",
    "position_company": "Position",
    "postalCode": "Zip/Postal Code",
    "poster": "Poster",
    "prefix": "Prefix",
    "previewPdf": "Preview PDF",
    "previewSuccessfullyCompleted": "Preview successfully completed",
    "price": "Price",
    "priceBase": "Base price",
    "priceBase_short": "B. price",
    "priceCost": "Management costs",
    "priceCost_short": "M. Costs",
    "priceCost_short_alt": "Manag. Costs",
    "priority": "Priority",
    "privateNote": "Private note",
    "producer": "Producer",
    "product": "Product",
    "products": "Products",
    "productsNotFound": "No products found",
    "province": "Region",
    "public": "Public",
    "purchaseRenovationDate": "Purchase/renovation date",
    "pushNotification": "Push notification",
    "quantity": "Quantity",
    "quantity_short": "Qty.",
    "question": "Question",
    "receivers": "Receivers",
    "recipient": "Recipient",
    "recipients": "Recipients",
    "recipientsAutomaticallyAddedToAllReports": "Recipients automatically added to all reports",
    "recoverEventCapacity": "Recover enclosure capactity",
    "redeemTicketOfficeWatermark": "Watermark 'Redeem at Ticket office'",
    "refundAmount": "Refund amount",
    "refunded": "Returned",
    "refunded_fem": "Returned",
    "refundeds": "Returned",
    "refundeds_fem": "Returned",
    "registrationDate": "Registration date",
    "registrationDate_short": "Regis. date",
    "registrationFees": "Registration fees",
    "relatedDiscounts": "Related discounts",
    "rememberMeOnThisComputer": "Remember me on this computer",
    "rememberUser": "Remember user",
    "removeConfiguration": "Remove configuration",
    "renewable": "Renewable",
    "report": "Report",
    "reportEmails": "Report emails",
    "reports": "Reports",
    "reportsUpdatedSuccessfully": "Reports updated successfully",
    "requiredFor": "Required for",
    "resend": "Resend",
    "resendCouldNotBeDone": "Error resending",
    "resendSuccessfully": "Resend successfully",
    "resendToNewEmail": "Resend to different email (optional)",
    "resend_1": "Subscription resend",
    "resend_2": "Subscription gift resend",
    "resend_3": "Subscription renovation resend",
    "resend_6": "Ticket resend",
    "responsible": "Responsible",
    "return": "Return",
    "returnCouldNotBeDone": "Error returning",
    "returnSuccessfully": "Return successfully",
    "return_1": "Subscription return",
    "return_2": "Subscription gift return",
    "return_3": "Subscription renovation return",
    "return_6": "Ticket return",
    "return_noun": "Return",
    "returns": "Returns",
    "reviewSessions": "Review sessions",
    "role": "Role",
    "roles": "Roles",
    "rolesForThisMarket": "Roles for this market",
    "rowsPerPage": "Rows per page",
    "saleDate": "Sale date",
    "saleDateFrom": "Sale date from",
    "saleDateTo": "Sale date to",
    "saleDays": "Sale days",
    "salesFrom": "Sales from",
    "salesReportEmails": "Sales report emails",
    "salesTo": "Sales to",
    "save": "Save",
    "savedSuccessfully": "Saved successfully",
    "savingSessions": "Saving sessions",
    "score": "Score",
    "search": "Search",
    "searchSubscriber": "Search subscriber",
    "search_dots": "Search...",
    "seating": "Seating",
    "seatingAT": "Abonoteatro seating",
    "seatingTemplate": "Seating template",
    "seatingsAndPrices": "Seatings and prices",
    "section": "Section",
    "seeCodes": "See codes",
    "seeEnclosureDetails": "See enclosure details",
    "seeFile": "See file",
    "seeFile_sheet": "See file",
    "seeTags": "See tags",
    "select": "Select",
    "selectAll": "Select All",
    "selectAllMarkets": "Select all markets",
    "selectAllSameOperations": "Select all operations of the same type",
    "selectAllSessionsAdvice": "You must select at least one session to continue.",
    "selectAllSessionsWithoutTemplates": "Select all sessions without templates",
    "selectDefault": "Select an option",
    "selectedRows_one": "{{count}} selected row",
    "selectedRows_other": "{{count}} selected rows",
    "send": "Send",
    "sendAndClose": "Send and close",
    "sendByAction": "Sending by action",
    "sendByHour": "Sending at specific time",
    "sendCopyToSubscriberEmail": "Send copy to the subscriber email",
    "sendSMS": "Send SMS",
    "sendSmsCounter": "Sending {{count}} SMS",
    "sendingFrequency": "Sending frequency",
    "separatedByCommas": "Separated by commas",
    "separator": ",",
    "session": "Session",
    "sessionAlreadyHasTicketConfigAndAllowedTickets": "The session has been saved with the ticket configuration",
    "sessionDate": "Session date",
    "sessionDay": "Session day",
    "sessionExpired": "Session expired",
    "sessionFinishByAction": "Session finish by action",
    "sessionFinishByDatetime": "Session finish by datetime",
    "sessionFinishByHour": "Session finish by hour",
    "sessionFrom": "Session from",
    "sessionHasNoTemplate": "The session does not have a template",
    "sessionHasNoTicketCodesAndTemplates": "Incomplete configuration (required codes and templates)",
    "sessionHour": "Session hour",
    "sessionSaved": "Session saved",
    "sessionStatus": "Session status",
    "sessionTo": "Session to",
    "session_plural": "Sessions",
    "session_singular": "Session",
    "sessions": "Sessions",
    "sessionsCalendar": "Sessions calendar",
    "sessionsEndDate": "Sessions end date",
    "sessionsNumber": "Sessions number",
    "sessionsNumber_short": "N sessions",
    "sessionsSaved": "Sessions saved",
    "sessionsStartDate": "Sessions start date",
    "settings": "Settings",
    "settlementByAccompanyingTicket": "Settlement for accompanying ticket",
    "settlementBySubscriberTicket": "Settlement for subscriber entry",
    "settlementEmails": "Settlement emails",
    "settlements": "Settlements",
    "shortDescription": "Short description",
    "showDatetimeFields": "Show date and time fields",
    "showOnlyWithErrors": "Show only with errors",
    "showPassword": "Show password",
    "sidebar": "Sidebar",
    "sold": "Sold",
    "soldSubscriptions": "Sold subscriptions",
    "soldUnits": "Sold units",
    "sold_fem": "Sold",
    "solds": "Sold",
    "solds_fem": "Sold",
    "sorry": "Sorry",
    "specificRecipients": "Specific recipients",
    "specificTimeDispatch": "Specific time dispatch",
    "start": "Start",
    "startOfSaleSetForMoreThanAYearFromNow": "Start of sale set for more than a year from now",
    "start_noun": "Start",
    "status": "Status",
    "stock": "Stock",
    "suboperation_short": "Sub",
    "subscriber": "Subscriber",
    "subscriberCosts": "Subscriber costs",
    "subscriberEmail": "Subscriber email",
    "subscriberInformation": "Subscriber information",
    "subscriberName": "Subscriber name",
    "subscriberNumber": "Subscriber number",
    "subscriberNumber_short": "Subs. Nr",
    "subscriberPVP": "Subscriber PVP",
    "subscriberPrice": "Subscriber price",
    "subscriberTicket": "Subscriber Ticket",
    "subscriberTickets": "Subscriber Tickets",
    "subscriberTickets_short": "Subs. Tick.",
    "subscriberUpdatedSuccessfully": "Subscriber updated successfully",
    "subscribers": "Subscribers",
    "subscribersEmails": "Subscribers emails",
    "subscription": "Subscription",
    "subscriptionCreatedSuccessfully": "Subscription created successfully",
    "subscriptionData": "Subscription data",
    "subscriptionDeletedSuccessfully": "Subscription deleted successfully",
    "subscriptionExpenses": "Subscription expenses",
    "subscriptionExpenses_resume": "Subscription - Expenses",
    "subscriptionNumber": "Subscription number",
    "subscriptionNumber_short": "Subs. Nr",
    "subscriptionPrice": "Subscription price",
    "subscriptionPrice_resume": "Subscription - Price",
    "subscriptionRevenueWithExpenses": "Subscription revenue with expenses",
    "subscriptionRevenues": "Subscription revenues",
    "subscriptionType": "Subscription type",
    "subscriptionTypeCreatedSuccessfully": "Subscription type created successfully",
    "subscriptionTypeDeletedSuccessfully": "Subscription type deleted successfully",
    "subscriptionTypeUpdatedSuccessfully": "Subscription type updated successfully",
    "subscriptionTypes": "Subscription types",
    "subscriptionUpdatedSuccessfully": "Subscription updated successfully",
    "subscriptions": "Subscriptions",
    "subscriptionsQuantity": "Subscriptions quantity",
    "subscriptionsUpdatedSuccessfully": "Subscriptions updated successfully",
    "subscriptionsWillBeResent_one": "{{count}} subscription will be resent",
    "subscriptionsWillBeResent_other": "{{count}} subscriptions will be resent",
    "subtitle": "Subtitle",
    "subtotal": "Subtotal",
    "successResendsInProgress": "Resend is in progress in the background",
    "successReturnsInProgress": "Refunds are in progress in the background",
    "suitableForMinors": "Suitable for all ages",
    "supportEmail": "Support email",
    "supportName": "Support name",
    "supportPhone": "Support phone",
    "synopsys": "Synopsys",
    "tags": "Tags",
    "template": "Template",
    "templateCreated": "Template created successfully",
    "templateDeleted": "Template deleted successfully",
    "templateDuplicated": "Template duplicated successfully",
    "templateName": "Template name",
    "templateUpdated": "Template updated successfully",
    "testEmail": "Test email",
    "testEmailSuccessfullySent": "Test email successfully sent",
    "thereAreCurrentlyNoReports": "There are currently no reports scheduled for this site.",
    "thereAreSessionsWithoutCodes": "There are sessions without codes",
    "thereAreSessionsWithoutCodes_one": "There is {{count}} session without codes",
    "thereAreSessionsWithoutCodes_other": "There are {{count}} sessions without codes",
    "thereIsNoUpdatedFields": "Only edited data will be saved. Please edit the desired fields to update sessions.",
    "thisActionCannotBeUndone": "This action cannot be undone",
    "ticket": "Ticket",
    "ticketCode": "Ticket code",
    "ticketCode_short": "Ticket code",
    "ticketExpenses": "Entry expenses",
    "ticketExpenses_resume": "Entry - Expenses",
    "ticketOfficeHours": "Ticket office hours",
    "ticketPrice": "Ticket price",
    "ticketPrice_resume": "Ticket - Price",
    "ticketType": "Ticket type",
    "ticketWillBeModified_one": "{{count}} ticket will be modified",
    "ticketWillBeModified_other": "{{count}} tickets will be modified",
    "tickets": "Tickets",
    "ticketsConfig": "Tickets Config.",
    "ticketsConfigUpdatedSuccessfully": "Tickets config updated successfully",
    "ticketsFormat": "Tickets format",
    "ticketsGeneration": "Tickets generation",
    "ticketsWillBeModified_one": "{{count}} ticket will be modified",
    "ticketsWillBeModified_other": "{{count}} tickets will be modified",
    "ticketsWillBeResent_one": "{{count}} ticket will be resent",
    "ticketsWillBeResent_other": "{{count}} tickets will be resent",
    "total": "Total",
    "totalIncome": "Total income",
    "totalManageCosts": "Total manage costs",
    "totalRefund": "Total refund",
    "totalRenewals": "Total renewals",
    "totalTicketsPerOperation": "Total entries per operation",
    "totalUses": "Total uses",
    "totalWithManagementExpenses": "Total with managment expenses",
    "totalWithoutManagementExpenses": "Total without managment expenses",
    "totals": "Totals",
    "township": "City",
    "type": "Type",
    "unassigned": "Unassigned",
    "updatePassword": "Update password",
    "updateSalesReport": "Update sales report",
    "updateSubscription": "Edit subscription",
    "updatedSuccessfully": "Updated successfully",
    "updatedSuccessfully_plural": "Updated successfully",
    "upload": "Upload",
    "uploadNewImage": "Upload new image",
    "user": "User",
    "userCreatedSuccessfullyAndEmailSended": "User created successfully and email sent to confirm password",
    "userEmail": "User email",
    "userManagement": "User management",
    "userName": "User name",
    "userUpdatedSuccessfully": "User updated successfully",
    "users": "Users",
    "valid": "Valid",
    "validFrom": "Valid from",
    "validUntil": "Valid until",
    "valid_current": "Valid",
    "validate": "Validate",
    "validated": "Validated",
    "validated_short": "Val.",
    "verified": "Verified",
    "viewMainOperationDetails": "View initial operation",
    "viewOperationDetails": "View operation details",
    "viewRenovateDetails": "View renovation details",
    "weAreSorry": "We are sorry",
    "webEdition": "Web edition",
    "webLink": "Enlace web",
    "webMessages": "Web messages",
    "webNotification": "Web notification",
    "webpages": "Webpages",
    "website": "Website",
    "websiteUpdatedSuccessfully": "Website updated successfully",
    "withNews": "With news",
    "wouldYouLikeToReturnTheTickets": "Would you like to return the tickets?",
    "wroteOnDatetime": "Wrote on {{date}} {{hour}}h",
    "yes": "Yes",
    "youAreGoingToCompleteThisPurchase": "You are going to complete the purchase of this operation.",
    "youAreGoingToMakeARefund_one": "You are going to make a refund of {{amount}}.",
    "youAreGoingToMakeARefund_other": "You are going to make a refund of {{amount}}.",
    "youAreGoingToMakeARefund_zero": "You are not going to refund any amount.",
    "youAreGoingToMakeASubscriptionResend_one": "You are going to resend {{count}} subscription.",
    "youAreGoingToMakeASubscriptionResend_other": "You are going to resend {{count}} subscriptions.",
    "youAreGoingToMakeATicketResend_one": "You are going to resend {{count}} ticket.",
    "youAreGoingToMakeATicketResend_other": "You are going to resend {{count}} tickets.",
    "youAreGoingToUpdateCapacity_one": "You are going to recover the capacity of {{count}} seat.",
    "youAreGoingToUpdateCapacity_other": "You are going to recover the capacity {{count}} seats.",
    "youAreGoingToUpdateCapacity_zero": "You are not going to update the capacity.",
    "youAreGoingToUpdateReport_one": "You are going to update the sales report.",
    "youAreGoingToUpdateReport_zero": "You are not going to update the sales report.",
    "youAreGoingToUpdateSubscription_one": "You are going to update {{quantity}} subscription.",
    "youAreGoingToUpdateSubscription_other": "You are going to update {{quantity}} subscriptions.",
    "youAreGoingToUpdateSubscription_zero": "You are not going to update any subscription.",
    "youtubeVideo": "Youtube video",
    "zone": "Zone",

    "confirmDialog": {
        "title": "Confirm action",
        "content": "Do you want to permanently delete {{deleteDescription}}?",
        "roleDescription": "This role will be removed from all users assigned to it",
        "role": "the role {{roleName}}?",
        "company": "the company: {{companyName}}?",
        "enclosure": "the enclosure: {{enclosureName}}?",
        "discount": "the discount code {{discount}}?",
        "event": "the event {{name}}?",
        "definitiveAction": "This action can not be undone.",
        "incidence": "the incidence {{codeNumber}}?",
        "subscriptionType": "the subscription type {{subscriptionType}}?"
    }
}
